import Header from "../UI/Header/Header";
import Section from "../UI/Section/Section";
import ServicePagePerks from "./Perks";
import ServicePageSkills from "./Skills";
import AdminTabs from "./AdminTabs/AdminTabs";

export default function ServicePage() {
  return (
    <>
      <Section>
        <AdminTabs />
      </Section>
      <Section>
        <ServicePagePerks />
      </Section>
      <Section>
        <ServicePageSkills />
      </Section>
      <Section>Удаление скилов и ачивок в базе данных вручную.</Section>
    </>
  );
}
